import { dialogClosed } from 'Core/actions/dialog';
import {
  forceVehicleSelection,
  forceVehicleSelectionLater,
  ignoreInexactFields,
  setVehicleDialogSelection,
  vehicleSpecificationNeeded,
} from 'Core/actions/fitmentSearch/index';
import { setResponse } from 'Core/actions/response';
import {
  createFilteredFitmentSearchResponseFieldsSelector,
  createFitmentSearchFieldsSelector,
  createFitmentSearchResponseFacetsSelector,
  createFitmentSearchResponseSelectionSelector,
  createResponseVehicleSelector,
  forceVehicleSelectionLaterSelector,
  isVehicleLandingFacetSelectedSelector,
  isVehicleSelectedSelector,
  isVehicleSelectionForcedSelector,
  selectedVehicleSelector,
  vehicleInexactSelector,
} from 'Core/selectors/fitmentSearch/index';
import { nonVehicleSpecificMessageSelector } from 'Core/selectors/search';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig';
import requestConfig from 'Models/uiConfig/requestConfig';
import { getVehicleFromUri } from 'Modules/converter/index';

import { epicFromHandlers } from '../common';

export default epicFromHandlers(
  {
    [dialogClosed.type]: ({ state, action: { payload } }) => {
      if (payload === 'VehicleWidgetDialog') {
        if (vehicleInexactSelector(state)) {
          return ignoreInexactFields();
        }

        if (isVehicleSelectionForcedSelector(state)) {
          return forceVehicleSelectionLater();
        }
      }
    },
    [setResponse.type]({
      state,
      action: {
        meta: { isolatedKey, onInit },
      },
    }) {
      if (isolatedKey !== null || !requestConfig.hasSearchResults || getVehicleFromUri().isVehicleNew) {
        return;
      }

      const nonVehicleSpecificResults = nonVehicleSpecificMessageSelector(state);
      const isVehicleLandingFacetSelected = isVehicleLandingFacetSelectedSelector(state);
      const { isReferrerInUrl } = requestConfig;

      if (nonVehicleSpecificResults || isVehicleLandingFacetSelected || isReferrerInUrl) {
        return;
      }

      const isVehicleSelected = isVehicleSelectedSelector(state);
      if (isVehicleSelected) {
        const selectedVehicle = selectedVehicleSelector(state);
        const responseVehicle = createResponseVehicleSelector(isolatedKey)(state);

        if (
          (!fitmentSearchConfig.forceSpecifyDialog && fitmentSearchConfig.isVehicleWidgetInPartialMode) ||
          !selectedVehicle.equals(responseVehicle)
        ) {
          return;
        }

        const responseFields = createFilteredFitmentSearchResponseFieldsSelector(isolatedKey)(state);
        const fitmentFields = createFitmentSearchFieldsSelector(isolatedKey)(state);
        const responseFitmentFields = responseFields.filter((f) => fitmentFields.includes(f));
        const selectedResponseFields = createFitmentSearchResponseSelectionSelector(isolatedKey)(state).map(
          (sel) => sel.field,
        );

        const selectedVehicleFields = new Set([
          ...selectedResponseFields,
          ...selectedVehicle.filter((v) => v.term === '__ignored').map((v) => v.field),
        ]);
        const missingFields = responseFitmentFields.filter((field) => !selectedVehicleFields.has(field));

        if (selectedResponseFields.length && missingFields.length) {
          return vehicleSpecificationNeeded(missingFields, isolatedKey);
        }
      } else {
        const shouldForceVehicleSelection =
          fitmentSearchConfig.forceVehicleSelection && onInit && !forceVehicleSelectionLaterSelector(state);

        const inVehicleSelectionProcess = createFitmentSearchResponseFacetsSelector(isolatedKey)(
          state,
        )._facets.some((f) => f.selection.length > 0);

        if (!inVehicleSelectionProcess && shouldForceVehicleSelection) {
          return forceVehicleSelection();
        }
      }
    },
    [vehicleSpecificationNeeded.type]: ({ state, action: { meta: { isolatedKey } = {} } }) => {
      return !isolatedKey && setVehicleDialogSelection(selectedVehicleSelector(state).selection);
    },
  },
  'specifyVehicle',
);
